<template>
  <div>
    <h1 class="has-text-uppercase has-text-link is-size-4 my-4">
      {{ $t("page.headers.notifications") }}
    </h1>
    <div v-for="(notification_list, i) in index" :key="i">
      <h3 class="notification-day">{{ i }}</h3>
      <ul class="notifications-list mb-3">
        <li
          class="mb-1"
          v-for="notification in notification_list"
          :key="notification.id"
        >
          <notification-visit-card
            v-if="notification.notification_type == 'Visit'"
            @expanded="onExpanded"
            :element="notification"
          ></notification-visit-card>
          <notification-incidence-card
            v-if="notification.notification_type == 'Incidence'"
            @expanded="onExpanded"
            :element="notification"
          ></notification-incidence-card>
          <notification-enquiry-comment-card
            v-if="notification.notification_type == 'Enquiry'"
            :element="notification"
            @expanded="onExpanded"
          ></notification-enquiry-comment-card>
          <notification-card
            v-if="!notification.notification_type"
            :element="notification"
            @expanded="onExpanded"
          ></notification-card>
        </li>
      </ul>
    </div>

    <div class="mb-1">
      <button
        class="button is-link is-outlined is-fullwidth"
        v-if="next"
        @click="nextPage()"
      >
        {{ $t("page.labels.show_more") }}
      </button>
    </div>
  </div>
</template>

<script>
import api from "@/api"
import NotificationCard from "@/components/NotificationCard"
import NotificationEnquiryCommentCard from "@/components/NotificationEnquiryCommentCard"
import NotificationIncidenceCard from "@/components/NotificationIncidenceCard"
import NotificationVisitCard from "@/components/NotificationVisitCard"

const PAGESIZE = 10

export default {
  name: "NotificationsList",
  components: {
    NotificationCard,
    NotificationEnquiryCommentCard,
    NotificationIncidenceCard,
    NotificationVisitCard,
  },
  mounted() {
    this.init()
  },
  data() {
    return {
      notifications: [],
      index: {},
      count: 0,
      next: null,
    }
  },
  methods: {
    init() {
      api._get(`bikenta/notifications/?page_size=${PAGESIZE}`).then((response) => {
        response.data.results.forEach((element) => {
          element.expanded = false
        })
        this.notifications = response.data.results
        this.count = response.data.count
        this.next = response.data.next
        this._mapIndex()
      })
    },
    nextPage() {
      api._rawGet(`${this.next}`).then((response) => {
        response.data.results.forEach((element) => {
          element.expanded = false
        })

        this.notifications = this.$_.union(this.notifications, response.data.results)
        this.next = response.data.next
        this._mapIndex()
      })
    },
    _mapIndex() {
      this.index = {}
      this.notifications.forEach((n) => {
        const d = new Date(n.created_on)
        let i = d.toLocaleString().split(" ")[0]
        this.index[i] = this.index[i] || []
        this.index[i].push(n)
      })
    },
    onExpanded(notification) {
      if (notification.read_status === "unread") {
        api.setNotificationAsRead(notification.id)
        notification.read_status = "read"
      }
    },
  },
}
</script>
